/**
 * 新版首页站点数据源（自 vancheen-b2b 的 site.js 移植为 Vue 2 版本）
 * ---------------------------------------------------------------
 * 原版基于 Vue 3 computed；这里改为函数式取值 getSite(key)，
 * 组件在 computed 中调用（如 `PILLARS() { return getSite('PILLARS') }`），
 * 依赖 nh-i18n 的 Vue.observable 语言状态，语言切换时自动更新。
 */
import { currentLocale } from './nh-i18n'
import * as en from './nh-site.en'
import * as zh from './nh-site.zh'

const DICTS = { en, zh }

/** 取当前语言下的某个导出；若该语言缺失则回落英文 */
export function getSite(key) {
  const dict = DICTS[currentLocale()] || DICTS.en
  const value = dict[key]
  return value === undefined ? DICTS.en[key] : value
}

export default getSite
